import { createAction } from 'redux-actions';
import {
  CHARTIQ_DRAW_CHANGE_LINE_PARAMS,
  CHARTIQ_DRAW_CHANGE_TOOL,
  CHARTIQ_DRAW_SET_FILL_COLOR,
  CHARTIQ_DRAW_SET_FILL_STYLE,
  CHARTIQ_DRAW_SET_FONT_FAMILY,
  CHARTIQ_DRAW_SET_FONT_SIZE,
  CHARTIQ_DRAW_SET_FONT_STYLE,
  CHARTIQ_DRAW_SET_LINE_COLOR,
  CHARTIQ_DRAW_TOGGLE_DRAWING,
  CHARTIQ_DRAW_TOGGLE_DRAWING_TOOLBAR,
} from './constants';

export const changeTool = createAction(
  CHARTIQ_DRAW_CHANGE_TOOL,
  (params: any) => params,
);

export const setFillColor = createAction(
  CHARTIQ_DRAW_SET_FILL_COLOR,
  (params: any) => params,
);

export const setFillStyle = createAction(
  CHARTIQ_DRAW_SET_FILL_STYLE,
  (params: any) => params,
);

export const setFontFamily = createAction(
  CHARTIQ_DRAW_SET_FONT_FAMILY,
  (params: any) => params,
);

export const setFontSize = createAction(
  CHARTIQ_DRAW_SET_FONT_SIZE,
  (params: any) => params,
);

export const setFontStyle = createAction(
  CHARTIQ_DRAW_SET_FONT_STYLE,
  (params: any) => params,
);

export const setLineColor = createAction(
  CHARTIQ_DRAW_SET_LINE_COLOR,
  (params: any) => params,
);

export const setLineParams = createAction(
  CHARTIQ_DRAW_CHANGE_LINE_PARAMS,
  (params: any) => params,
);

export const toggleDrawing = createAction(
  CHARTIQ_DRAW_TOGGLE_DRAWING,
  (params: any) => params,
);

export const toggleDrawingToolbar = createAction(
  CHARTIQ_DRAW_TOGGLE_DRAWING_TOOLBAR,
  (params: any) => params,
);

